import { createStrictContext as a } from "../../util/context/createStrictContext.js";
import { useState as o } from "react";
import { jsx as u } from "react/jsx-runtime";
const [f, x] = a("LogicControl"), L = (r) => {
  const {
    children: t
  } = r, [e, n] = o(!1), [c, s] = o(!1), [l, i] = o(null);
  return /* @__PURE__ */ u(f, {
    value: {
      forceLogout: e,
      generalError: l,
      warnNetworkOnly: c,
      setForceLogout: n,
      setGeneralError: i,
      setWarnNetworkOnly: s
    },
    children: t
  });
};
export {
  L as LogicControlProvider,
  x as useLogicControlContext
};
//# sourceMappingURL=LogicControlContext.js.map
